// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import updateLoadParameter from "@bg/App/Handlers/CustomQuote/UpdateLoadParameters";
import { CustomAppState } from "@bg/App/Store/Reducers";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select, { SelectProps } from "@insite/mobius/Select";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomAppState) => {
    return {
        sortOption: state.myCustomQuotes.getCustomQuotesParameter.sort,
    };
};

const mapDispatchToProps = {
    updateLoadParameter,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface MyListsSortControlStyles {
    wrapper?: InjectableCss;
    select?: SelectProps;
}

export const sortControlStyles: MyListsSortControlStyles = {
    select: {
        cssOverrides: {
            formField: css`
                flex-direction: row;
                align-items: center;
                label {
                    width: auto;
                    font-weight: ${fontConfig.weight.bold};
                    font-size: ${fontConfig.fontSize.small}px;
                    margin-right: 8px;
                    white-space: nowrap;
                }
                @media (max-width: 650px) {
                    flex-direction: column;
                    align-items: flex-start;
                }
            `,
            formInputWrapper: css`
                margin-top: 0 !important;
            `,
            inputSelect: css`
                font-size: ${fontConfig.fontSize.small}px;
                height: 32px;
            `,
        },
        iconProps: {
            css: css`
                display: inline;
                &&&&&& {
                    top: auto;
                }
            `,
        },
    },
};

const styles = sortControlStyles;

const sortChangeHandler = (event: React.FormEvent<HTMLSelectElement>, props: Props) => {
    props.updateLoadParameter({ sort: event.currentTarget.value });
};

const MyCustomQuotesSortControl: React.FunctionComponent<Props> = props => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Select
                label={translate("Sort By")}
                data-test-selector="myCustomQuotes"
                {...styles.select}
                onChange={(event: React.FormEvent<HTMLSelectElement>) => sortChangeHandler(event, props)}
            >
                <option value="ModifiedOn DESC">{translate("Last Updated")}</option>
                <option value="Name ASC">{translate("List Name: A-Z")}</option>
                <option value="Name DESC">{translate("List Name: Z-A")}</option>
            </Select>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyCustomQuotesSortControl),
    definition: {
        group: "My Custom Quotes" as any,
        displayName: "Sort Control",
        allowedContexts: ["MyCustomQuotesPage" as any],
    },
};

export default widgetModule;
